export const sections = [
    'All Centers',
    'Johannesburg, BSC',
    'Xiamen, BSC',
    'Quilmes, BSC',
    'Aguascalientes, BSC',
    'NAZ, BSC',
    'Jaguariuna, BSC',
    'Prague & India GCC',
    
];

export const sectionPaths = sections.reduce((acc, section) => {
  acc[section] = section;
  return acc;
}, {} as { [key: string]: string });